// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_background__U5\\+jp {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}

.Login_loginContainer__kub2- {
  display: flex;
  height: 100vh;
  width: 100%;
}

.Login_loginContainer__kub2- .Login_logo__j1HlC {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 30px;
}

.Login_formBg__kqiay {
  flex-grow: 1;
  position: relative;
}

.Login_loginForm__QiL9D {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.Login_inputs__PlIQy {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 400px;
}

.Login_loginContainer__kub2- h2 {
  font-size: 55px;
  font-weight: 600;
  line-height: 71.5px;
  color: white;
}

.Login_input__\\+gaU2 {
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  gap: 8px;
  border: 1px solid #ededed;
  color: #ededed;
  background-color: transparent;
  align-items: start;
}

.Login_input__\\+gaU2 input {
  color: #ededed;
  background-color: transparent;
  border: none;
}

.Login_loginBtn__n0So3 {
  width: 400px;
  height: 60px;
  border-radius: 8px;
  padding: 0px 16px;
  margin-top: 40px;
  line-height: 24px;
  color: #676c7e;
  border: none;
  cursor: pointer;
  background-color: white;
}

.Login_loginBtn__n0So3:disabled {
  background-color: rgb(219, 218, 218);
}

.Login_notifications__j3cIq {
  margin-top: 2rem;
}

.Login_loginForm__QiL9D input,
.Login_loginForm__QiL9D label {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/login/Login.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb","sourcesContent":[".background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-top-right-radius: 50px;\n  border-bottom-right-radius: 50px;\n}\n\n.loginContainer {\n  display: flex;\n  height: 100vh;\n  width: 100%;\n}\n\n.loginContainer .logo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0px 30px;\n}\n\n.formBg {\n  flex-grow: 1;\n  position: relative;\n}\n\n.loginForm {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.inputs {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 400px;\n}\n\n.loginContainer h2 {\n  font-size: 55px;\n  font-weight: 600;\n  line-height: 71.5px;\n  color: white;\n}\n\n.input {\n  padding: 8px 16px;\n  display: flex;\n  flex-direction: column;\n  border-radius: 12px;\n  gap: 8px;\n  border: 1px solid #ededed;\n  color: #ededed;\n  background-color: transparent;\n  align-items: start;\n}\n\n.input input {\n  color: #ededed;\n  background-color: transparent;\n  border: none;\n}\n\n.loginBtn {\n  width: 400px;\n  height: 60px;\n  border-radius: 8px;\n  padding: 0px 16px;\n  margin-top: 40px;\n  line-height: 24px;\n  color: #676c7e;\n  border: none;\n  cursor: pointer;\n  background-color: white;\n}\n\n.loginBtn:disabled {\n  background-color: rgb(219, 218, 218);\n}\n\n.notifications {\n  margin-top: 2rem;\n}\n\n.loginForm input,\n.loginForm label {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `Login_background__U5+jp`,
	"loginContainer": `Login_loginContainer__kub2-`,
	"logo": `Login_logo__j1HlC`,
	"formBg": `Login_formBg__kqiay`,
	"loginForm": `Login_loginForm__QiL9D`,
	"inputs": `Login_inputs__PlIQy`,
	"input": `Login_input__+gaU2`,
	"loginBtn": `Login_loginBtn__n0So3`,
	"notifications": `Login_notifications__j3cIq`
};
export default ___CSS_LOADER_EXPORT___;
